import { Button, Typography } from '@mui/material';
import styles from '../Information.module.scss'
import { useEffect, useState } from 'react';
import Religious from './religious';
import Human from './human';
import YouthandEducation from './youthandEducation';

const ServiceinformationTabComponent = () => {
    const [activeButton, setActiveButton] = useState<string | null>(null);
    const handleReligiousClick = () => {
        setActiveButton('religious');
    }
    const handleHumanClick = () => {
        setActiveButton('human');
    }
    const handleyouthandeducationClick = () => {
        setActiveButton('youtheducation')
    }
    useEffect(() => {
        setActiveButton('religious');
    }, [])
    return (
        <>
            <div className={styles.ServiceinformationTabcomponent}>
                <Typography className={styles.typoGraphyHeading}>Service Information</Typography>
                <div className={styles.buttonContainer}>
                    <Button
                        onClick={handleReligiousClick}
                        className={activeButton === 'religious' ? `${styles.activeButton}` : ''}
                    ><span style={{ textTransform: "none" }}>Religious</span></Button>
                    <Button
                        className={activeButton === 'human' ? styles.activeButton : ''}
                        onClick={handleHumanClick}
                    ><span style={{ textTransform: "none" }}>Human Services</span></Button>
                    <Button
                        className={activeButton === 'youtheducation' ? styles.activeButton : ''}
                        onClick={handleyouthandeducationClick}
                    ><span style={{ textTransform: "none" }}>Youth & Education</span></Button>
                </div>
                <div style={{ borderBottom: '2px solid #D4E2EA' }}></div>
            </div>
            {activeButton === 'religious' && <Religious/>}
            {activeButton === 'human' && <Human />}
            {activeButton === 'youtheducation' && <YouthandEducation />}
        </>
    )
}
export default ServiceinformationTabComponent;